<template>
    <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
        style="overflow: hidden;">
        <div class="m-portlet m-portlet--mobile">

            <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
                <!--begin: Search Form -->
                <div class="m-form m-form--label-align-right">
                    <div style="float: left;margin-top: 10px;">
                        <div class="m-form__group m-form__group--inline">
                            <div class="m-form__label">
                                <label style="width: 100px;text-align:right;">管理单元：</label>
                            </div>
                            <div class="m-form__control">
                                <el-select v-model="condition.secretarysec" filterable placeholder="全部">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="item in managesecOptions" :key="item.DictItemID"
                                        :label="item.DictItemName" :value="item.DictItemID">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="m-form__label">
                                <label style="width: 100px;text-align:right;">日期</label>
                            </div>
                            <div class="m-form__control">
                                <el-date-picker v-model="condition.cpdate" type="month" placeholder="选择日期范围"
                                    value-format="yyyy-MM"></el-date-picker>
                            </div>
                        </div>
                        <div class="d-md-none m--margin-bottom-10"></div>
                    </div>

                </div>
                <div style="clear: both;"></div>
                <div class="m--margin-top-10 m--margin-bottom-10"
                    style="width: 100%;text-align: center;float: initial;">
                    <!-- <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton> -->
                    <el-button type="primary" icon="el-icon-search" @click="StuSearch">查询</el-button>
                </div>
                <!--end: Search Form -->
                <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
                    <!--begin: Datatable -->
                    <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
                        <el-table-column prop="DictItemName" label="管理单元" width="300">
                        </el-table-column>
                        <el-table-column prop="InSecCnt" label="入科时间">
                            <template slot-scope="scope">
                                <a @click="handleColumnClick(scope.row, '1',scope.row.InSecCnt)"
                                    style="cursor: pointer;">{{
                                    scope.row.InSecCnt }}</a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="XcxCnt" label="形成性评价">
                            <template slot-scope="scope">
                                <a @click="handleColumnClick(scope.row, '2',scope.row.XcxCnt)"
                                    style="cursor: pointer;">{{
                                    scope.row.XcxCnt }}</a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="OutSecCnt" label="出科考核">
                            <template slot-scope="scope">
                                <a @click="handleColumnClick(scope.row, '3',scope.row.OutSecCnt)"
                                    style="cursor: pointer;">{{
                                    scope.row.OutSecCnt }}</a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="MonthExamCnt" label="月度考核">
                            <template slot-scope="scope">
                                <a @click="handleColumnClick(scope.row, '4',scope.row.MonthExamCnt)"
                                    style="cursor: pointer;">{{
                                    scope.row.MonthExamCnt }}</a>
                            </template>
                        </el-table-column>

                    </el-table>
                    <!--end: Datatable -->
                    <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="condition.currentPage" :page-sizes="[2, 10, 20, 30, 40]"
                            :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
                            :total="condition.recordCount">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!--弹出层-->
        <el-dialog :visible.sync="dialogVisible" width="60%">
            <el-table :data="detailData" stripe style="width: 100%" size="medium">
                <el-table-column prop="StuName" label="姓名" width="200"></el-table-column>
                <el-table-column prop="InDate" label="入科时间">
                    <template slot-scope="scope">
                        {{ scope.row.InDate?scope.row.InDate.split('T')[0]:'' }}
                    </template>
                </el-table-column>
                <el-table-column prop="XcxDate" label="形成性评价时间">
                    <template slot-scope="scope">
                        {{ scope.row.XcxDate?scope.row.XcxDate.split('T')[0]:'' }}
                    </template>
                </el-table-column>
                <el-table-column prop="OutDate" label="出科考核时间">
                    <template slot-scope="scope">
                        {{ scope.row.OutDate?scope.row.OutDate.split('T')[0]:'' }}
                    </template>
                </el-table-column>
                <el-table-column prop="MonthDate" label="月度考核时间">
                    <template slot-scope="scope">
                        {{ scope.row.MonthDate?scope.row.MonthDate.split('T')[0]:'' }}
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'Abnormalstatistics',
        data () {
            return {
                condition: {
                    token: '',
                    cpdate: new Date().getFullYear() + "-" + (new Date().getMonth()),
                    secretarysec: ''
                },
                loading: false,
                managesecOptions: [],
                tableData: null,
                searchUrl: this.$utils.Url.zpgl + '/api/APICPI/GetAbnormalStatistics',
                dialogVisible: false,
                detailData: []
            }
        },
        created () {
            window.Info = this.Info
        },
        methods: {
            handleColumnClick (row, colNum, count) {
                if (count == 0) {
                    return
                }
                // 在这里处理点击事件，请求后台显示详细数据，将rowNum通过参数传递到后台，
                // 然后在后台根据rowNum获取详细数据并返回给前端，前端将返回的数据显示在弹窗中。
                // 例如：
                var args = {
                    token: this.condition.token,
                    secretarysec: row.SecID,
                    cpdate: row.searchDate,
                    colnum: colNum
                }
                var that = this
                this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICPI/GetAbnormalStatisticsDetail', args, function (data) {
                    console.log(data)
                    // 在这里处理返回的数据，将其显示在弹窗中。
                    if (data.Code === 0) {
                        // 在这里处理返回的数据，将其显示在弹窗中。
                        that.dialogVisible = true;
                        that.detailData = data.Data;
                    } else {
                        that.$message({
                            message: '获取数据失败',
                            type: 'error'
                        })
                    }
                }, null, null, null);
            },
            LoadManageSec: function () {
                var args = {
                    token: this.condition.token,
                    username: this.condition.username,
                    rolelevel: this.condition.rolelevel
                }
                var that = this
                this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function (data) {
                    that.managesecOptions = data.Data
                }, null, null, null)
            },
            StuSearch: function () {
                let that = this
                that.$http.post(that.searchUrl, that.condition)
                    .then(res => {
                        if (res.data.Code === 0) {
                            that.tableData = res.data.Data
                        } else {
                            that.$message({
                                message: res.data.Msg + '，' + res.data.Error,
                                type: 'error'
                            })
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        that.$message({
                            message: '查询失败',
                            type: 'error'
                        })
                    })
            },
        },
        mounted: function () {
            this.condition.token = sessionStorage.getItem('token')
            this.condition.username = sessionStorage.getItem('username')
            this.condition.rolelevel = sessionStorage.getItem('rolelevel')
            var date = new Date()
            var year = date.getFullYear()
            this.LoadManageSec()
            this.condition.grantbeginyear = String(year) + "-1"
            this.condition.grantendyear = String(year) + "-12"
            this.condition.token = sessionStorage.getItem('token')
            this.StuSearch()
            // this.$refs.btnSearch.Search()
        },
        watch: {
            'condition.cpdate': {
                handler (newVal) {
                    if (newVal && newVal.length < 8) {
                        this.condition.cpdate = newVal + '-01'
                    }
                },
                immediate: true
            }
        },
    }
</script>

<style scoped="scoped">
    ::v-deep .el-input {
        width: 220px;
    }
</style>